import { CloseOutlined, DownOutlined, UpOutlined } from '@ant-design/icons'
import { App, Tooltip } from 'antd'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from 'store'
import { findNextTag, findPreviousTag, unselectTag } from 'store/editor'
import { getFoundParagraphIds } from 'store/editor/selector'

export const SearchTag: React.FC = () => {
  const { t } = useTranslation()
  const { message } = App.useApp()
  const dispatch = useAppDispatch()

  const selectedTagId = useAppSelector(state => state.editor.selectedTag)
  const paragraphs = useAppSelector(state => getFoundParagraphIds(state))
  const selectedParagraph = useAppSelector(state => state.editor.selectedParagraph)
  const selectedTagName = useAppSelector(state => {
    return state.transcript.tags[state.editor.selectedTag]?.name
  })

  const next = useCallback(async () => {
    await dispatch(findNextTag({ message, t }))
  }, [])

  const prev = useCallback(async () => {
    await dispatch(findPreviousTag({ message, t }))
  }, [])

  if (!selectedTagId) {
    return null
  }

  return (
    <Tooltip
      placement="right"
      title={
        <span style={{ marginLeft: '20px' }}>{`${
          paragraphs.indexOf(selectedParagraph) + 1
        } ${t('search-tag-of')} ${paragraphs.length}`}</span>
      }
    >
      <div
        style={{
          alignItems: 'center',
          background: '#EB6435',
          borderRadius: '8px',
          color: '#FFF',
          display: 'flex',
          height: '42px',
          marginRight: '30px',
          padding: '0 20px',
          whiteSpace: 'nowrap',
        }}
      >
        <UpOutlined style={{ marginRight: '10px' }} onClick={() => {
          void prev()
        }} />
        <div
          style={{
            background: '#ffffff39',
            height: '36px',
            marginLeft: '5px',
            marginRight: '5px',
            width: '1px',
          }}
        />
        <h4 style={{
          color: '#FFF',
          marginBottom: '0',
          padding: '10px',
        }}>
          {selectedTagName}
        </h4>
        <div
          style={{
            background: '#ffffff39',
            height: '36px',
            marginLeft: '5px',
            marginRight: '5px',
            width: '1px',
          }}
        />
        <DownOutlined style={{ margin: '0 10px' }} onClick={() => {
          void next()
        }} />

        <CloseOutlined
          style={{ marginLeft: '10px' }}
          onClick={() => dispatch(unselectTag())}
        />
      </div>
    </Tooltip>
  )
}
